import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function ListExportButton({
  onExport,
}: {
  readonly onExport: (format: 'csv' | 'xlsx') => Promise<void>;
}) {
  const { t } = useTranslation('common');
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState<'limit' | 'other' | null>(null);
  async function run(format: 'csv' | 'xlsx') {
    setBusy(true);
    setFailed(null);
    try {
      await onExport(format);
    } catch (error) {
      setFailed(
        typeof error === 'object' &&
          error !== null &&
          'code' in error &&
          error.code === 'EXPORT_ROW_LIMIT_EXCEEDED'
          ? 'limit'
          : 'other',
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="flex flex-wrap items-center gap-2" aria-busy={busy}>
      {(['csv', 'xlsx'] as const).map((format) => (
        <Button key={format} variant="outline" disabled={busy} onClick={() => void run(format)}>
          {t('list.export', { format: format.toUpperCase() })}
        </Button>
      ))}
      {failed ? (
        <span role="alert">
          {t(failed === 'limit' ? 'list.exportTooLarge' : 'list.exportError')}
        </span>
      ) : null}
    </div>
  );
}
